import Show from './Show'
import HistoryList from './HistoryList'

const Details = () => (
  <div>
    <Show/>
    <HistoryList/>
  </div>
)

export default Details